<template>
  <div class="list-pagination">
    <a-pagination
      v-model:current="current"
      :total="total"
      :showSizeChanger="false"
      :pageSize="pageSize"
      @change="onChangePage"
      class="pagination"
      :showLessItems="true"
      :responsive="true"
    >

      <template #itemRender="{ type, originalElement }">
        <a v-if="type === 'prev'" class="prev">
          <img src="@/assets/images/arrow-right-gray.svg" />前へ
        </a>
        <a v-else-if="type === 'next'" class="next"
          > 次へ<img src="@/assets/images/arrow-right-gray.svg"
        /></a>
        <component :is="originalElement" v-else></component>
      </template>
    </a-pagination>
  </div>
</template>

<script >
export default {
  props: {
    showPageSize: {
      type: Boolean,
    },
    showPageBottom: {
      type: Boolean,
    },
    total: {
      default: 0,
      type: Number,
    },
    pageSize: {
      default: 1,
      type: Number,
    },
    page: {
      default: 1,
      type: Number,
    },
  },
  methods: {
    onChangePage() {
      this.$emit('currentPage', this.current);
    },
  },
  data() {
    return {
      current: this.page,
    };
  },
  computed: {

  },
  emits: ['currentPage'],
};
</script>

<style lang="scss">
</style>
